import React from "react";
import TauriImage from "../TauriImage/TauriImage";
import './TauriBrand.css';

const TauriBrand = ({ brand }) => {
    return (
        <a className="navbar-brand col-md-3 col-lg-2 m-0" href="#">
            {brand?.brandImage ? (
                <div
                    className="d-none d-sm-block"
                >
                    <TauriImage
                        localImage={brand.brandImage}
                        alt={brand?.brandName || 'Brand Logo'}
                        className="img-fluid"
                        color="#FFFFFF"
                        style={{ width: '110px' }}
                    />
                </div>
            ) : (
                <>
                    <span className="brandname d-none d-sm-block">
                        {brand?.brandName}
                    </span>
                </>
            )}
        </a>
    );
};

export default TauriBrand;